import React from 'react';
import classNames from 'classnames';
import BaseNavigation, { BaseNavigationProps } from './BaseNavigation';

const PrimaryNavigation = ({ className, ...rest }: BaseNavigationProps) => <BaseNavigation className={classNames(className, 'primary-nav')} {...rest} />;

export default PrimaryNavigation;
